module.exports = __webpack_public_path__ + "static/media/homeButtonOutline.5cdc3f39.svg";